<template>
    <div
        class="input-number__outer"
        :class="[{ dirty: isDirty, clean: isClean }]"
    >
        <label class="input-number__label" :class="{ required }">
            {{ labelText }}
        </label>
        <div class="input-number__wrapper">
            <input
                type="number"
                ref="input"
                :value="value"
                :placeholder="placeholderText"
                @input="updateInput()"
                @change="inputChanged()"
                :required="required"
                autocomplete="chrome-off"
            />
            <span v-if="append" class="input-number__append">
                {{ append }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: ['value', 'placeholder', 'required', 'label', 'append'],
    computed: {
        labelText() {
            if (this.label) {
                return this.label;
            }
            return this.placeholder;
        },
        placeholderText() {
            if (this.required) {
                return `${this.placeholder}*`;
            }
            return this.placeholder;
        },
        isDirty() {
            return typeof this.value !== 'undefined' && this.value;
        },
        isClean() {
            return typeof this.value === 'undefined' || !this.value;
        },
    },
    methods: {
        updateInput() {
            this.$emit('input', this.$refs.input.value);
        },
        inputChanged() {
            this.$emit('change');
        },
    },
};
</script>

<style lang="scss" scoped>
.input-number__wrapper {
    border: 1px solid #bcb4b0;
    border-radius: 4px;
    overflow: hidden;
    height: 40px;
    padding-left: 12px;
    padding-right: 12px;
    position: relative;

    &:after {
        transition: box-shadow 0.3s ease-in;
    }

    input {
        border: 0;
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding: 0;
        font-weight: 500;
        color: #4e3a30;
        &::-webkit-input-placeholder {
            color: rgba(78, 58, 48, 0.6);
        }
        &:focus {
            outline: 0;
            &::-webkit-input-placeholder {
                opacity: 0;
            }
        }
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input {
        -moz-appearance: textfield;
    }

    &.error {
        border-color: #e3342f;
    }

    &.input--high {
        font-size: 20px;
        height: 60px;
        input {
            height: 60px;
            line-height: 60px;
        }
    }

    &:focus-within {
        border-color: transparent;
        &:after {
            content: '';
            border-radius: 4px;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            box-shadow: inset 0 0 0 2px #c8532b;
            pointer-events: none;
        }
    }

    .input-number__placeholder {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        pointer-events: none;
        color: rgba(78, 58, 48, 0.6);
    }

    .input-number__append {
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translateY(-50%);
        color: rgba(78, 58, 48, 0.6);
    }
}

.input-number__outer {
    position: relative;
    padding-top: 5px;
    .input-number__label {
        display: inline-block;
        position: absolute;
        top: 5px;
        left: 10px;
        padding-left: 2px;
        padding-right: 6px;
        background-color: #fff;
        transform: translateY(-50%);
        font-size: 14px;
        color: rgba(78, 58, 48, 1);
        z-index: 1;

        &.required::after {
            content: '*';
            color: #c8532b;
        }
    }

    &.clean {
        .input-number_label {
            display: none;
        }
        &:focus-within {
            .input-number_label {
                display: inline-block;
            }
        }
    }

    &:focus-within {
        .input-number__label {
            color: #c8532b;
        }
    }

    &.input--high,
    .input-number__wrapper {
        font-size: 20px;
        height: 60px;
        input {
            height: 60px;
            line-height: 60px;
        }
    }
}
</style>
